export const getTags = (state) => state.tags.tags;

export const getTagsByCategory = (state, category) => {
  const tags = getTags(state);
  return tags.filter((tag) => tag.categories.includes(category));
};

export default getTags;
